import { useCallback } from "react";

/**
 * Canva ya no usa el script "Design Button" (sdk.canva.com/designbutton).
 * La integración es Canva Connect API (OAuth + REST) vía backend: ver `connectApi.ts`.
 */
export function useCanvaCore() {
  const initCanva = useCallback(() => {
    /* noop — reservado por compatibilidad con App.tsx */
  }, []);

  return {
    initCanva,
  };
}

export { fetchCanvaConnection } from "./connectApi";
